import { IKeyContact } from '../Cards/KeyContactsPanel';

// These should match USCM.Feature.NowNavigation.Models.SliderPanelType
export enum SLIDERPANELTYPES {
  RICHTEXTBOX = 'RICHTEXTBOX',
  ALERT = 'ALERT',
  CUSTOMERACCOUNTLOOKUP = 'CUSTOMERACCOUNTLOOKUP',
  LINKSPANEL = 'SECTIONLINKS',
  FAVORITESPANEL = 'FAVORITESPANEL',
  KEYCONTACTSPANEL = 'CONTACTSPANEL',
  MOCKPANEL = 'MOCKPANEL',
  QUOTEPANEL = 'QUOTEPANEL',
}
export type SliderPanelType =
  | RichTextPanelType
  | AlertPanelType
  | CustomerAccountPanelType
  | LinksPanelType
  | FavoritesPanelType
  | KeyContactsPanelType
  | MockPanelType
  | QuotePanelType;

export type RichTextPanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.RICHTEXTBOX;
  linkBoxes?: {
    text: string;
    States: string[];
  }[];
};
export type AlertPanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.ALERT;
};
export type LinksPanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.LINKSPANEL;
  sections: IReactNavSection[];
};
export type FavoritesPanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.FAVORITESPANEL;
  link?: string;
  sections: IReactNavSection[];
};
export type MockPanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.MOCKPANEL;
};
export type QuotePanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.QUOTEPANEL;
};
export type CustomerAccountPanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.CUSTOMERACCOUNTLOOKUP;
  sections: IReactNavSection[];
};

export type KeyContactsPanelType = SliderPanelBaseType & {
  type: SLIDERPANELTYPES.KEYCONTACTSPANEL;
  link?: string;
  sections: IReactNavSection[];
  ContactSection: IContactSection[];
};

export type SliderPanelBaseType = {
  icon: IIcon;
  title: string;
  sortorder: string;
  goal: string;
  id: string;
};

export interface ISliderSettings {
  activeTab?: string;
  isOpen: boolean;
  pinned: boolean;
}

export type IIcon = {
  alt: string;
  src: string;
};

export type ISliderContext = {
  favorites: string[] | undefined;
  addFavorite: (id: string | undefined, favoriteType: string) => void;
  removeFavorite: (id: string | undefined) => void;
  setFavorites: (ids: string[]) => void;
  contactPanel: KeyContactsPanelType | undefined;
  addContactsPanel: (panel: KeyContactsPanelType) => void;
  contacts?: IKeyContact[];
  setContacts: (contacts: IKeyContact[]) => void;
  contactsLoading?: boolean;
  setContactsLoading: (loading: boolean) => void;
  panels: (FavoritesPanelType | KeyContactsPanelType | LinksPanelType)[] | undefined;
  addPanel: (panel: FavoritesPanelType | KeyContactsPanelType | LinksPanelType) => void;
};
